import * as Yup from 'yup';

export const UserProfileValidationSchema = (
) =>
	Yup.object().shape({
		firstName: Yup.string().required('Imię jest wymagane!'),
		lastName: Yup.string().required('Nazwisko jest wymagane!')
	});
